import { render, staticRenderFns } from "./button_plus.vue?vue&type=template&id=6abc22de&scoped=true&"
import script from "./button_plus.vue?vue&type=script&lang=js&"
export * from "./button_plus.vue?vue&type=script&lang=js&"
import style0 from "./button_plus.vue?vue&type=style&index=0&id=6abc22de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abc22de",
  null
  
)

export default component.exports